import { useApi } from '@backstage/core-plugin-api';
import { sev2ApiRef } from '@internal/backstage-plugin-sev2/src/api';
import { Project } from '@internal/backstage-plugin-sev2/src/types';
import { useEffect, useState } from 'react';
import { debounce } from '@mui/material/utils';

const useSev2ProjectCombobox: () => {
  loading: boolean;
  open: boolean;
  options: Project[];
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOptions: React.Dispatch<React.SetStateAction<Project[]>>;
  searchProjects: (search: string) => Promise<void>;
} = () => {
  const api = useApi(sev2ApiRef);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<Project[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const response = await api.getProjects({});

      if (active) {
        setOptions(response.result.data);
      }
    })();

    return () => {
      active = false;
    };
  }, [api, loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const searchProjects = debounce(async (search: string) => {
    const response = await api.getProjects({ projectName: search });
    setOptions(response.result.data);
  }, 500);

  return {
    loading,
    open,
    options,
    setOpen,
    setOptions,
    searchProjects,
  };
};

export default useSev2ProjectCombobox;
